export default __webpack_public_path__ + "static/media/commision-saved.f9b91697.svg";